export const translations = {
    title: {
        es: "Cuenta bloqueada por falta de pago",
        en: "Account blocked for non-payment"
    },
    description: {
        es: "Tu cuenta está bloqueada debido a un pago pendiente, por lo que no tienes acceso a la plataforma. Contáctanos para regularizar el pago y reactivarla.",
        en: "Your account is blocked due to an outstanding payment, so you have no access to the platform. Contact us to settle the payment and reactivate your account."
    },
    contactPrompt: {
        es: "Contáctanos para resolverlo:",
        en: "Contact us to sort it out:"
    },
    email: {
        es: "Email",
        en: "Email"
    },
    whatsapp: {
        es: "WhatsApp",
        en: "WhatsApp"
    },
    chat: {
        es: "Chat",
        en: "Chat"
    }
}
